let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kB78Y")).then(() => parcelRequire('azIHD'));